<template>
    <div class="w-full h-full flex flex-col">
        <div class="flex border-gray-200 border-b h-8 overflow-hidden mb-1 ">
            <div class="flex-grow">
                <h1 class="text-brand text-lg font-extrabold mb-2 ">
                    <span class="ml-4 whitespace-nowrap"><i class="far fa-address-card mr-4"></i>Calendar</span>
                </h1>
            </div>
            <div class="w-auto text-xs align-top text-brand mt-1">
                <div class="inline-block align-top mt-1 mr-1">Weeks</div>
                <div class="inline-block">
                    <ui-toggle
                        v-model="viewMonth"
                    ></ui-toggle>
                </div>
                <div class="inline-block align-top mt-1 ml-1">Months</div>
            </div>
        </div>
        <main class="overflow-hidden flex-1">
            <calendar-view
                :key="calKey"
                :show-date="showDate"
                :starting-day-of-week="1"
                :enable-date-selection="true"
                :items="items"
                :display-period-uom="viewMonth?'month':'week'"
                :display-period-count="1"
                class="theme-default"
                @click-item="editItem"
                @click-date="addItem"
            >
                <calendar-view-header
                    slot="header"
                    slot-scope="t"
                    :header-props="t.headerProps"
                    @input="setShowDate"/>
            </calendar-view>
        </main>
    </div>
</template>

<script>
import {CalendarView, CalendarViewHeader} from "vue-simple-calendar"
import UiToggle from "../../../../ui/UiToggle.vue";
import moment from "moment";
import {uuid} from "../../../../../utils";
import User from "../../../../../services/User";
import remoteStorage from "../../../../../utils/remoteStorage";

export default {
    components: {UiToggle, CalendarView, CalendarViewHeader},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            user: false,
            viewMonth: true,
            showDate: new Date(),
            calKey: 0,
            items: [],
            classes: 'border border-gray-200 rounded-lg bg-gray-50 ml-1 px-1 text-xs text-gray-500 truncate hover:bg-gray-100 hover:text-gray-800',
        }
    },
    computed: {},
    methods: {
        setShowDate(d) {
            this.showDate = d
        },
        addItem(date, calendarItems, event) {
            this.$modals.open('package-user-calendar-add-item', {
                title: `Add new item to "${moment(date).format('DD/MM/YYYY')}"`,
                button: 'Add',
                handle: async (data, modal) => {
                    this.items.push({
                        id: uuid(),
                        startDate: date,
                        title: modal.description,
                        classes: this.classes
                    })
                    this.saveItems();
                }
            })
        },
        editItem(calendarItem, event) {
            this.$modals.open('package-user-calendar-edit-item', {
                title: `Edit item on "${moment(calendarItem.startDate).format('DD/MM/YYYY')}"`,
                button: 'Save',
                desc: calendarItem.title,
                handle: async (data, modal) => {
                    if (modal.description) {
                        this.items.find((i) => i.id === calendarItem.id).title = modal.description
                    } else {
                        this.items.splice(this.items.findIndex((i) => i.id === calendarItem.id), 1)
                    }
                    this.saveItems();
                }
            })
        },
        loadItems() {
            let data = remoteStorage.getItem('package-calendar-widget-items-' + this.dashboardData.package.id, []);
            this.items = [];
            data.forEach((d) => {
                this.items.push({
                    id: d.id,
                    startDate: d.date,
                    title: d.description,
                    classes: this.classes
                })
            })
        },
        saveItems() {
            let data = [];
            this.items.forEach((item) => {
                data.push({id: item.id, date: item.startDate, description: item.title});
            })
            remoteStorage.setItem('package-calendar-widget-items-' + this.dashboardData.package.id, data);
        }
    },
    async mounted() {
        await User.register();
        this.user = User.user
        this.loadItems()
    }
}
</script>
<style>
/* Header */

.theme-default .cv-header .periodLabel {
    font-size: 1em;
    justify-content: flex-end;
}

.cv-header button {
    font-size: 0.9em;
}

.cv-header button {
    font-size: 0.8em;
}
.cv-header-nav button {
    padding: .4em .4em
}
.theme-default .cv-header button {
    color: #7f7f7f;
}

.theme-default .cv-header button:disabled {
    color: #ccc;
    background-color: #f7f7f7;
}

/* Grid */

.theme-default .cv-weeknumber {
    background-color: #e0e0e0;
    border-color: #ccc;
    color: #808080;
}

.theme-default .cv-weeknumber span {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.theme-default .cv-day {
    background-color: #FFFFFF;
}

.theme-default .cv-day.outsideOfMonth {
    background-color: transparent;
}

.theme-default .cv-day.outsideOfMonth .cv-day-number {
    background-color: transparent;
    opacity: 30%;
}

.theme-default .cv-day.today {
    background-color: rgb(0 136 206 / var(--tw-bg-opacity, 1));
}

.theme-default .cv-day:hover {
    background-color: #FFE;
}

.theme-default .dow6 {
    background-color: rgb(249, 250, 251);
}

.theme-default .dow0 {
    background-color: rgb(249, 250, 251);
}

.theme-default .cv-day.today .cv-day-number {
    color: #FFFFFF
}

.theme-default .cv-day.today:hover .cv-day-number {
    color: #3D3E44
}

.theme-default .cv-day[aria-selected] {
    background-color: #ffc;
}

/* Events */

.theme-default .cv-item {
    text-overflow: ellipsis;
    width: calc(14.28571% - .50rem);
}

.theme-default .cv-item:hover {
    background: #FFE
}

.theme-default .cv-item.continued::before,
.theme-default .cv-item.toBeContinued::after {
    content: " \21e2 ";
    color: #999;
}

.theme-default .cv-item.toBeContinued {
    border-right-style: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.theme-default .cv-item.isHovered.hasUrl {
    text-decoration: underline;
}

.theme-default .cv-item.continued {
    border-left-style: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.cv-item.span3,
.cv-item.span4,
.cv-item.span5,
.cv-item.span6,
.cv-item.span7 {
    text-align: center;
}

/* Event Times */

.theme-default .cv-item .startTime,
.theme-default .cv-item .endTime {
    font-weight: bold;
    color: #666;
}

/* Drag and drop */

.theme-default .cv-day.draghover {
    box-shadow: inset 0 0 0.2em 0.2em yellow;
}


</style>